// Initialize namespace
Sparkle.PageBuilder = Sparkle.PageBuilder || {};
Sparkle.PageBuilder.Components = Sparkle.PageBuilder.Components || {};
Sparkle.PageBuilder.Components.Behavior = Sparkle.PageBuilder.Components.Behavior || {};

Sparkle.PageBuilder.Components.Behavior = class Behavior {
  static LOOKUP = {};

  static {
    this.prototype.events = {};
  }

  static lookup(name, element) {
    const behavior = this.LOOKUP[name];
    if (behavior != null) {
      return new behavior(element);
    } else {
      return new this();
    }
  }

  static register(name) {
    return (this.LOOKUP[name] = this); // Components can declare events and handlers using Backbone.View's events syntax
  }

  constructor(el) {
    this.onRender = this.onRender.bind(this);
    this.beforeRender = this.beforeRender.bind(this);
    this.initialize = this.initialize.bind(this);
    this.initializeEvents = this.initializeEvents.bind(this);
    this.initializeIntersectionObserver = this.initializeIntersectionObserver.bind(this);
    this.render = this.render.bind(this);
    this.el = $(el);
    this.el.data("component-behavior", this);
    this.uuid = this.el.data("uuid");

    this.initialize();
    this.initializeEvents();
    this.initializeIntersectionObserver();

    // BEHAVIOUR
    this.el.on("pb:component:render", this.onRender); // Treat pagebuilder render events as render calls
  }

  // HOOKS

  // Hook to execute code when the component is rendered client-side
  // NOTE: The initial server-side render does not fire this callback
  onRender() {}

  beforeRender(html) {
    return html;
  }

  // Hook to execute code when the component is first visible in the viewport
  // This stub is commented out because we want to check if a callback is defined before adding an IntersectionObserver
  // onFirstVisible: =>

  // Hook to do initialization work once the component has been instantiated
  initialize() {}

  // HELPER FUNCTIONS

  initializeEvents() {
    return $.each(this.events, (eventSelectorPair, handler) => {
      const [event, selector] = Array.from(eventSelectorPair.split(" "));
      // Resolve the handler at dispatch time: initializeEvents runs inside the
      // base constructor (during the subclass's super() call), before the
      // subclass constructor has bound its methods. Attaching `this[handler]`
      // here would register the unbound prototype method, which jQuery then
      // invokes with `this` set to the DOM element.
      return this.el.on(event, selector, (...args) => this[handler](...args));
    });
  }

  initializeIntersectionObserver() {
    if (typeof this.onFirstVisible !== "function") {
      return;
    }

    if (!IntersectionObserver) {
      return this.onFirstVisible();
    }

    var intersectionObserver = new IntersectionObserver((entries) => {
      // If isIntersecting is false, the target is out of view and we do not need to do anything
      if (!entries[0].isIntersecting) {
        return;
      }

      // Ensure we don't double load if multiple intersection events are queued before we call `disconnect`
      if (this.intersectionTriggered) {
        return;
      }

      this.intersectionTriggered = true;
      intersectionObserver.disconnect();

      return this.onFirstVisible();
    });

    return intersectionObserver.observe(this.el.get(0));
  }

  // Rerender the component server-side
  // Can be used on cached pages to refresh dynamic content
  render() {
    const params = Object.fromEntries(new URLSearchParams(location.search));
    params.api = "inline";

    let componentUrl = window.SparkleConfig.routes.embed.component.replace("COMPONENT_UUID", this.uuid);
    componentUrl = window.Sparkle.apiHost ? window.Sparkle.apiHost + componentUrl : componentUrl;
    return $.get(componentUrl, params).done((html) => {
      html = this.beforeRender(html);
      this.el.html(html);
      return this.onRender();
    });
  }

  // Returns true if we're executing on the sandbox domain
  isSandbox() {
    return new RegExp(window.SparkleConfig.sandbox.subdomain).test(window.top.location.hostname);
  }
};
